import VideoPlayer               from './VideoPlayer';
import type {IVideoPlayerConfig} from './@types';

export {
    VideoPlayer,
    IVideoPlayerConfig
}
